import classNames from 'classnames';
import { Button } from '@quero-delivery/quero-components-web';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Modal } from '@querodelivery/uni-react';
import { Checkbox } from '@/_components/checkbox';
import styles from './styles.module.scss';
import type { InfosProps, ModalConfirmInfosProps } from './types';
import { ENUM_TITLES_SECTION } from '../../constants';
import type { ENUM_DENIED_REASONS } from '../footer-reasons/constants';
import { LABEL_DENIED_REASONS } from '../footer-reasons/constants';
import { MODAL_WIDTH } from '@/_constants/styles';

function ModalConfirmInfos({
  open,
  onClose,
  onSubmit,
  isLoadingButton,
}: ModalConfirmInfosProps) {
  const { getValues } = useFormContext();

  const valuesInfos = getValues();

  const infos = useMemo(() => {
    const {
      hasApprovedPersonalData,
      commentsPersonalData,
      hasApprovedBankAccount,
      commentsBankAccount,
      hasApprovedRg,
      commentsRg,
      hasApprovedCnh,
      commentsCnh,
      hasApprovedCrlv,
      commentsCrlv,
      hasApprovedSelfieWithRg,
      commentsSelfieWithRg,
      hasApprovedDeliverymanPicture,
      commentsDeliverymanPicture,
      valuesReasons,
    } = valuesInfos;

    const infoArray: InfosProps[] = [
      {
        name: ENUM_TITLES_SECTION.PERSONAL_DATA,
        status: hasApprovedPersonalData,
        comment: commentsPersonalData,
      },
      {
        name: ENUM_TITLES_SECTION.BANK_DATA,
        status: hasApprovedBankAccount,
        comment: commentsBankAccount,
      },
      {
        name: ENUM_TITLES_SECTION.ID_DOCUMENT,
        status: hasApprovedRg,
        comment: commentsRg,
      },
      {
        name: ENUM_TITLES_SECTION.DRIVER_LICENSE,
        status: hasApprovedCnh,
        comment: commentsCnh,
      },
      {
        name: ENUM_TITLES_SECTION.VEHICLE_REGISTRATION,
        status: hasApprovedCrlv,
        comment: commentsCrlv,
      },
      {
        name: ENUM_TITLES_SECTION.SELFIE_WHIT_DOCUMENT,
        status: hasApprovedSelfieWithRg,
        comment: commentsSelfieWithRg,
      },
      {
        name: ENUM_TITLES_SECTION.SELFIE,
        status: hasApprovedDeliverymanPicture,
        comment: commentsDeliverymanPicture,
      },
    ];

    if (valuesReasons && valuesReasons.value) {
      valuesReasons.value.forEach((reason: ENUM_DENIED_REASONS) => {
        infoArray.push({
          name: LABEL_DENIED_REASONS[reason],
          status: false,
        });
      });
    }

    return infoArray.filter(info => info.status !== undefined);
  }, [valuesInfos]);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width={MODAL_WIDTH.md}
      header="Confirme as informações abaixo:"
    >
      <div className={styles.container}>
        {infos.map(info => (
          <div key={info.name} className={styles.containerInfo}>
            <div className={styles.infoContainer}>
              <Checkbox
                classNameLabel={classNames(
                  styles.labelCheckbox,
                  info.status
                    ? styles.labelCheckboxApproved
                    : styles.labelCheckboxReproved,
                )}
                classNameCheckbox={classNames(
                  info.status
                    ? styles.checkboxInfoApproved
                    : styles.checkboxInfoReproved,
                )}
                id={info.name}
                data-testid={info.name}
                label={info.status ? 'Aprovado' : 'Reprovado'}
                checked
              />
              <h3 className={styles.infoName}>{info.name}</h3>
            </div>
            {info.comment && (
              <input
                data-testid={`${info.name}-comment`}
                aria-label={info.comment}
                readOnly
                value={info.comment}
              />
            )}
          </div>
        ))}

        {valuesInfos?.valuesReasons?.comment && (
          <div className={styles.containerInfo}>
            <input
              data-testid="reasons-comment"
              aria-label={valuesInfos?.valuesReasons?.comment}
              readOnly
              value={valuesInfos?.valuesReasons?.comment}
            />
          </div>
        )}

        <div className={styles.containerButtons}>
          <Button secondary width="100%" onClick={() => onClose()}>
            Editar
          </Button>
          <Button
            loading={isLoadingButton}
            className={styles.button}
            onClick={onSubmit}
            width="100%"
          >
            Enviar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ModalConfirmInfos };
